var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.001,
    cy: 94.0024,
    rx: 5.00245,
    ry: 5.00245,
    transform: "rotate(90 158.001 94.0024)",
    fill: "#00FFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 191.723,
    y: 2,
    width: 27.7236,
    height: 27.7236,
    rx: 13.8618,
    transform: "rotate(90 191.723 2)",
    fill: "#F2E9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.746 23.5H64.2546C62.7447 23.5417 61.2659 23.94 59.9375 24.6627C58.6091 25.3853 57.4686 26.4122 56.608 27.6601L40.2353 50.4501C39.0196 52.1772 38.4124 54.2631 38.5102 56.3766C38.608 58.4901 39.4051 60.5103 40.7751 62.1165L89.8931 119.001C90.7341 120.091 91.8116 120.972 93.0433 121.578C94.2751 122.185 95.6285 122.5 97 122.5C98.3715 122.5 99.7249 122.185 100.957 121.578C102.188 120.972 103.266 120.091 104.107 119.001L153.225 62.1165C154.595 60.5103 155.392 58.4901 155.49 56.3766C155.587 54.2631 154.981 52.1772 153.765 50.4501L137.392 27.6601C136.532 26.4122 135.391 25.3853 134.063 24.6627C132.735 23.94 131.255 23.5417 129.746 23.5Z",
    stroke: "url(#paint0_linear_4373_115764)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3194 23.5L70.3594 57.7379L96.9994 122.5",
    stroke: "url(#paint1_linear_4373_115764)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.95 23.5L123.82 57.7379L97 122.5",
    stroke: "url(#paint2_linear_4373_115764)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6797 57.79H155.32",
    stroke: "url(#paint3_linear_4373_115764)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5424 93.0089C37.9994 93.1688 37.9993 93.8309 37.5423 93.9906C30.4752 96.4598 28.0472 98.8129 25.4863 105.654C25.3205 106.097 24.6791 106.097 24.5131 105.654C21.95 98.8157 19.5244 96.4626 12.4576 93.9911C12.0006 93.8312 12.0007 93.1691 12.4577 93.0094C19.5248 90.5402 21.9528 88.1871 24.5137 81.3461C24.6795 80.9031 25.3209 80.903 25.4869 81.3459C28.05 88.1843 30.4756 90.5374 37.5424 93.0089Z",
    fill: "url(#paint4_linear_4373_115764)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4373_115764",
    x1: 154.171,
    y1: 72.1885,
    x2: -29.4949,
    y2: 145.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4373_115764",
    x1: 96.6966,
    y1: 72.1885,
    x2: 48.6544,
    y2: 76.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4373_115764",
    x1: 123.515,
    y1: 72.1885,
    x2: 75.1537,
    y2: 76.5983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4373_115764",
    x1: 153.994,
    y1: 58.2818,
    x2: 153.857,
    y2: 63.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4373_115764",
    x1: 38.6818,
    y1: 93.2787,
    x2: -6.69822,
    y2: 109.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.56c35b7f3ab9770a7115e2816dc535db.svg";
export { ForwardRef as ReactComponent };